import store from '~/store';

export default id => {
    const user = store.getState().users.models[id];
    return user ? user.name : 'System';
};
